import styled from 'styled-components';

interface ModeSelectionButtonProps {
  readonly active: boolean;
}

export const ModeSelectionButton = styled.div<ModeSelectionButtonProps>`
  font-family: ${(props) => props.theme.font.primaryFamily};
  font-size: ${(props) => props.theme.font.text.light.small.fontSize};
  font-weight: ${(props) => props.theme.font.text.light.small.fontWeight};
  letter-spacing: ${(props) => props.theme.font.text.light.small.letterSpacing};
  line-height: 20px; // todo: theme?

  cursor: pointer;
  padding: 10px;
  border-radius: ${(props) => props.theme.borderRadius.box};

  text-decoration: ${(props) => (props.active ? 'underline' : 'none')};
  color: ${(props) => props.theme.palette.text.primary};
  transition:
    color ${(props) => props.theme.transition.theme},
    background-color ${(props) => props.theme.transition.theme};

  &:hover {
    background-color: ${(props) =>
      props.active ? props.theme.palette.input.background.active : props.theme.palette.input.background.hover};
  }
`;
